import industryConfigurations from 'src/global/constants/industryConfigurations';
import { postRequest } from './requests';

class ConfigurationService {
  loadAll = () => {
    const data = {
      Configuracoes: industryConfigurations,
    };

    const configuration = new Promise((resolve, reject) => {
      postRequest(
        `/genericos/ge/configuracao/CarregarConfiguracoes`,
        data,
        resolve,
        reject
      );
    });

    configuration.then(response => {
      if (response.length) {
        const configs = response.map(config => ({
          id: config.Sequencia,
          value:
            typeof config.Valor === 'string'
              ? config.Valor.trimEnd()
              : config.Valor,
        }));

        localStorage.setItem('configuration', JSON.stringify(configs));
      }
    });
  };

  loadWithPromise = config => {
    const data = {
      Configuracoes: [config],
    };

    return new Promise((resolve, reject) => {
      postRequest(
        `/genericos/ge/configuracao/CarregarConfiguracoes`,
        data,
        resolve,
        reject
      );
    });
  };
}

export default new ConfigurationService();
